// extracted by mini-css-extract-plugin
export var title = "projects-section-module--title--38wn1";